import { Routes } from '@angular/router';
import { UnsavedChangesGuard } from '../../@core/guards';

export const customersSettingsChildRoutes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'customer-details', pathMatch: 'full' },
      {
        path: 'customer-details',
        loadComponent: () => import('./customer-details/customer-details.component').then((m) => m.CustomerDetailsComponent),
        canDeactivate: [UnsavedChangesGuard],
      },
      {
        path: 'media-preferences',
        loadComponent: () => import('./media-preferences/media-preferences.component').then((m) => m.MediaPreferencesComponent),
        canDeactivate: [UnsavedChangesGuard],
      },
      {
        path: 'team',
        loadComponent: () => import('./team/team.component').then((m) => m.TeamComponent),
      },
      {
        path: 'features',
        loadComponent: () => import('./features/features.component').then((m) => m.FeaturesComponent),
        canDeactivate: [UnsavedChangesGuard],
      },
    ],
  },
];
